
// BOOT_VISION_CONSTANTS is injected by the backend.
// This way we don't need to keep these configs in sync with the backend manually.

const config = window.BOOT_VISION_CONFIG

export default config
